import {useEffect, useId, useState} from "react";
import {useParams} from "react-router-dom";
import {BreadCrumbs} from "../../../components/open/pages";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {CheckIcon, ThinPersonIcon, ThinUndoIcon} from "../../../components/icons/material-icons";
import {StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GregorianToPersian} from "../../../components/techaran/date-convert";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";

interface chatInterface {
    id:number,
    isByStudent:boolean,
    message:string,
    createdAt:string,
}

export const AdminsConsultRequestViewScreen = () => {
    const {requestId} = useParams();
    const [data,setData] = useState({
        loaded:false,
        student:0,
        name:'',
        hasProfile:false,
        description:'',
        createdAt:'2000-01-01 00:00:00',
        isSessionHeld:false,
        isAnswered:false,
        chats:[] as chatInterface[],
    });
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/admins/consult/requests/get',
            {
                request:requestId,
            },
            true,
            (d: {
                result: string,
                reason: string,
                student:number, // id
                name:string,
                hasProfile:boolean,
                description:string,
                createdAt:string,
                isSessionHeld:boolean,
                isAnswered:boolean,
                chats:[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setData({
                    loaded: true,
                    chats: d.chats === null ? [] : d.chats,
                    hasProfile: d.hasProfile,
                    createdAt: d.createdAt,
                    description: d.description,
                    name: d.name,
                    student: d.student,
                    isAnswered: d.isAnswered,
                    isSessionHeld: d.isSessionHeld,
                });
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "مشاهده درخواست | مشاوره | اتوماسیون";
        fetchData();
    }, []);
    const toggleStatus = () => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/consult/requests/toggle-status',
            {
                request:requestId,
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowProgressLoading();
                fetchData();
                ShowSnackbar(
                    'وضعیت درخواست تغییر یافت.',
                    'باشه',
                    5000,
                );
            },
            () => {},
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const newMessageId = useId();
    const [newMessage, setNewMessage] = useState('');
    const [newMessageErr, setNewMessageErr] = useState(false);
    const [sendSms,setSendSms] = useState(true);
    const sendMessage = () => {
        const sms = sendSms;
        const m = newMessage.trim();
        if(m.length < 3){
            setNewMessageErr(true);
            return;
        }
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/consult/requests/chat',
            {
                request:requestId,
                message:m,
                sms:sms ? '1' : '0',
            },
            true,
            (d: {
                result:string,
                reason:string|undefined,
            })=>{
                HideProgressLoading();
                if(d.result !== 'OK'){
                    if(d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowProgressLoading();
                fetchData();
                ShowSnackbar(
                    'پیام جدید ارسال گردید.',
                    'باشه',
                    5000,
                );
            },
            ()=>{
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'مشاوره', url: '/admins/consult'},
                {title: 'درخواست ها', url: '/admins/consult/requests'},
                {title: 'مشاهده درخواست', url: `/admins/consult/requests/view/${requestId}`},
            ]}/>
            {
                data.loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>مشاهده دخواست</b>
                                <button onClick={toggleStatus}>
                                    {data.isSessionHeld ? <ThinUndoIcon/> : <CheckIcon/>}
                                    <span>{!data.isSessionHeld ? 'تغییر به برگزار شده' : 'تغییر به درانتظار'}</span>
                                </button>
                            </div>
                            <b style={{display:'block',}}>عنوان تیکت: {data.description}</b>
                            <span style={{display:'block',fontSize:14,marginTop:5}}>وضعیت جلسه : {data.isSessionHeld ? 'برگزار شده' : 'در انتظار'}</span>
                            <hr/>
                            {
                                data.chats.map((m, i) =>
                                    <div
                                        key={"K39fm3jsAsA2A"+i}
                                        className={"row justify-content-" + (m.isByStudent ? 'end' : 'start')}>
                                        <div className="col-md-6">
                                            <div className="ticket-message">
                                                <div>
                                                    <i><ThinPersonIcon/></i>
                                                    <b>{!m.isByStudent ? 'مشاور مدرسه' : data.name}</b>
                                                </div>
                                                <p>{m.message}</p>
                                                <span>{StringDigitsConvertToPersian(m.createdAt.split(' ')[1]) + " " + StringDigitsConvertToPersian(GregorianToPersian(m.createdAt.split(' ')[0])).replaceAll('-', '/') }</span>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            <hr/>
                            <div className="row justify-content-center">
                                <div className="col-lg-6">
                                    <label htmlFor={newMessageId}>پیام جدید:</label>
                                    <textarea
                                        id={newMessageId}
                                        className={"form-control" + (newMessageErr ? ' is-invalid' : '')}
                                        value={newMessage}
                                        style={{minHeight: 200, maxHeight: 500}}
                                        onChange={e => {
                                            let t = e.currentTarget.value;
                                            setNewMessage(t);
                                            setNewMessageErr(false);
                                        }}/>
                                    <div className={"invalid-feedback" + (newMessageErr ? ' d-block' : ' d-none')}>
                                        لطفا حداقل ۳ کاراکتر وارد کنید.
                                    </div>
                                    <div style={{marginTop: 20}}/>
                                    <button className={"techaran-checkbox" + (sendSms ? ' active' : '')}
                                            onClick={() => setSendSms(v => !v)}>
                                        <i><CheckIcon/></i>
                                        <span>
                                    ارسال پیامک
                                    <em>ارسال پیامک اطلاع‌رسانی پاسخ جدید به والدین.</em>
                                </span>
                                    </button>
                                    <div className="d-flex justify-content-end align-items-center"
                                         style={{marginTop: 20}}>
                                        <button className="btn-pay" onClick={sendMessage}>
                                            <b>ارسال پیام</b>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : null
            }
        </>
    );
};